import {createSelector} from 'reselect';
import {getListingPage} from './store';
import {OpenModalStates} from '../records/listingPageRecord';

const isDatePickerModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return (
            openModalState === OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER ||
            openModalState === OpenModalStates.INQUIRY_DATE_PICKER ||
            openModalState === OpenModalStates.MAIN_PAGE_DATE_PICKER ||
            openModalState === OpenModalStates.BOOKING_FLOW_DATE_PICKER
        );
    }
);

const isGuestSelectorModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return (
            openModalState === OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR ||
            openModalState === OpenModalStates.INQUIRY_GUEST_SELECTOR ||
            openModalState === OpenModalStates.MAIN_PAGE_GUEST_SELECTOR ||
            openModalState === OpenModalStates.BOOKING_FLOW_GUEST_SELECTOR
        );
    }
);

const isRequestToBookModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return (
            openModalState === OpenModalStates.REQUEST_TO_BOOK ||
            openModalState === OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER ||
            openModalState === OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR
        );
    }
);

const isInquiryModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return (
            openModalState === OpenModalStates.INQUIRY ||
            openModalState === OpenModalStates.INQUIRY_DATE_PICKER ||
            openModalState === OpenModalStates.INQUIRY_GUEST_SELECTOR
        );
    }
);

const isLocationModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.LOCATION;
    }
);

const isMapModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.MAP;
    }
);

const isToiMapModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.TOI_MAP;
    }
);

const isCivilCodeDisclaimerModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.CIVIL_CODE_DISCLAIMER;
    }
);

const isDescriptionModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.DESCRIPTION;
    }
);

const isGeneratedDescriptionModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.GENERATED_DESCRIPTION;
    }
);

const isUnitDescriptionModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.UNIT_DESCRIPTION;
    }
);

const isReviewsModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.REVIEWS;
    }
);

const isAmenityModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.AMENITY;
    }
);

const isOwnerProfileModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.OWNER_PROFILE;
    }
);
// Host profile test
const isHostProfileModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.HOST_PROFILE;
    }
);

const isSearchModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return (
            openModalState === OpenModalStates.SEARCH ||
            openModalState === OpenModalStates.SEARCH_DATE_PICKER ||
            openModalState === OpenModalStates.SEARCH_GUEST_PICKER
        );
    }
);

const isSearchDatePickerOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.SEARCH_DATE_PICKER;
    }
);

const isSearchGuestPickerOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.SEARCH_GUEST_PICKER;
    }
);

const isVirtualTourModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {openModalState} = listingPage;

        return openModalState === OpenModalStates.VIRTUAL_TOUR;
    }
);

const isVerticalGalleryModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.openModalState === OpenModalStates.VERTICAL_GALLERY;
    }
);

const isImageCarouselModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.openModalState === OpenModalStates.IMAGE_CAROUSEL;
    }
);

const isCancellationPolicyModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.openModalState === OpenModalStates.CANCELLATION_TIMELINE;
    }
);

const getListingPageModalStates = createSelector(
    [
        isCivilCodeDisclaimerModalOpen,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isImageCarouselModalOpen,
        isInquiryModalOpen,
        isLocationModalOpen,
        isMapModalOpen,
        isToiMapModalOpen,
        isDescriptionModalOpen,
        isUnitDescriptionModalOpen,
        isGeneratedDescriptionModalOpen,
        isReviewsModalOpen,
        isAmenityModalOpen,
        isSearchModalOpen,
        isSearchDatePickerOpen,
        isSearchGuestPickerOpen,
        isVerticalGalleryModalOpen,
        isVirtualTourModalOpen,
        isCancellationPolicyModalOpen
    ],
    (
        civilCodeDisclaimerModalOpen,
        datePickerModalOpen,
        guestSelectorModalOpen,
        requestToBookModalOpen,
        imageCarouselModalOpen,
        inquiryModalOpen,
        locationModalOpen,
        mapModalOpen,
        toiModalOpen,
        descriptionModalOpen,
        unitDescriptionModalOpen,
        generatedDescriptionModalOpen,
        reviewsModalOpen,
        amenityModalOpen,
        searchModalOpen,
        searchDatePickerOpen,
        searchGuestPickerOpen,
        verticalGalleryModalOpen,
        virtualTourModalOpen,
        cancellationPolicyModalOpen
    ) => {
        return {
            civilCodeDisclaimerModalOpen,
            datePickerModalOpen,
            guestSelectorModalOpen,
            requestToBookModalOpen,
            imageCarouselModalOpen,
            inquiryModalOpen,
            locationModalOpen,
            mapModalOpen,
            toiModalOpen,
            descriptionModalOpen,
            unitDescriptionModalOpen,
            generatedDescriptionModalOpen,
            reviewsModalOpen,
            amenityModalOpen,
            searchModalOpen,
            searchDatePickerOpen,
            searchGuestPickerOpen,
            verticalGalleryModalOpen,
            virtualTourModalOpen,
            cancellationPolicyModalOpen
        };
    }
);

export default getListingPageModalStates;
export {
    getListingPageModalStates,
    isCivilCodeDisclaimerModalOpen,
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen,
    isLocationModalOpen,
    isMapModalOpen,
    isToiMapModalOpen,
    isDescriptionModalOpen,
    isGeneratedDescriptionModalOpen,
    isUnitDescriptionModalOpen,
    isReviewsModalOpen,
    isAmenityModalOpen,
    isOwnerProfileModalOpen,
    isHostProfileModalOpen,
    isVerticalGalleryModalOpen,
    isVirtualTourModalOpen,
    isCancellationPolicyModalOpen
};
